import { formatString } from '@maistodos/design-system-web'

import { Currency } from './types'

const currencies: Currency = {
  pt_BR: 'BRL',
  es_CO: 'COP',
  es_CL: 'CLP',
} as const

const languages: Currency = {
  pt_BR: 'pt-BR',
  es_CO: 'es-CO',
  es_CL: 'es-CL',
} as const

// O CLDR passou a formatar COP sem centavos, e o Intl acompanha o dado de
// moeda da versao do Node. Fixamos os digitos aqui para o valor exibido nao
// mudar junto com um bump de Node.
const fractionDigits: Record<string, number> = {
  COP: 2,
}

const getLocaleCurrency = (lang: string) => {
  if (lang in currencies) {
    return currencies[lang] ?? currencies[languages.pt_BR]
  }
  return currencies.pt_BR
}

export const formatLocaleCurrency = (val: number, lang: string) => {
  const currency = getLocaleCurrency(lang)
  const digits = fractionDigits[currency]

  return new Intl.NumberFormat(languages[lang] ?? languages.pt_BR, {
    style: 'currency',
    currency,
    ...(digits !== undefined && {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    }),
  }).format(val)
}

export const formatLocaleCustomerDocument = (
  document: string,
  lang: string,
) => {
  if (lang !== 'pt_BR') {
    return document
  }

  if (document.length >= 14) {
    return formatString(document, 'dd.ddd.ddd/dddd-dd')
  }

  return formatString(document, 'ddd.ddd.ddd-dd')
}

export const isLanguageSupported = (lang: string | undefined) => {
  if (lang && Object.keys(languages).includes(lang)) {
    return lang
  }
  return undefined
}
